

function splitCountrySubdivisionCode(code) {
    //eg. GB-SCT
    const [countryCode, subdivision] = code.split("-");
    return { countryCode, subdivision };
}

/**
 * Returns the country iso 2 code from Country Subdivision Code (eg. GB-SCT)
 * @param {string} countrySubdivisionCode
 * @returns {string}
 */
export function getCountryIso2(countrySubdivisionCode) {
   //eg. GB-SCT => GB
   const { countryCode } = splitCountrySubdivisionCode(countrySubdivisionCode);

   return countryCode;
}